import React from "react";
import { Button } from "@mui/material";
import { useSnackbar } from "notistack5";

const useCustomConfirmSnackBar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showSnackbar = (
    title,
    variant = "success",
    confirmAction,
    rejectAction
  ) => {
    enqueueSnackbar(title, {
      variant: variant,

      action: (key) => (
        <>
          <Button
            onClick={() => {
              confirmAction();
              closeSnackbar(key);
            }}
            color="primary"
            size="small"
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              closeSnackbar(key);
              rejectAction && rejectAction();
            }}
            color="error"
            size="small"
          >
            No
          </Button>
        </>
      ),
      anchorOrigin: {
        horizontal: "center",
        vertical: "top",
      },
      autoHideDuration: null,
    });
  };

  return showSnackbar;
};

export default useCustomConfirmSnackBar;
// enqueueSnackbar("Are you sure you want to delete?", {
//     variant: "warning",
//     action: (key) => (
//       <>
//         <Button
//           onClick={() => {
//             handleDelete(item.userid);
//             closeSnackbar(key);
//           }}
//           color="primary"
//           size="small"
//         >
//           Yes
//         </Button>
//         <Button
//           onClick={() => closeSnackbar(key)}
//           color="error"
//           size="small"
//         >
//           No
//         </Button>
//       </>
//     ),
//   })
